import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { Controller } from 'react-hook-form';
import { daysOfWeek, timeStringTodatetime } from '../../../../../utils/datetime';
import { KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import UserSelectionField from "./UserSelectionField";

const DAYS = daysOfWeek();

const useStyles = makeStyles(theme => ({
  // DialogTitle
  occurrences: {
    '& h3': {      
      color: props => props.isEditableForm ? 'black': 'gray'
    }
  },  
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: '1px 2px',
    '&.MuiChip-sizeSmall': {
      height: '14px',
      fontSize: '13px'
    }
  }
}));


function CourseForm(props){
  const classes = useStyles(props);
  const { isEditableForm, allowEditUsers, page } = props;
  // const allowEditUsers = true;
  const { user } = useSelector( state => state );
  const { categories } = useSelector(state => state);
  
  const { id, name, description, required_books, occurrences, office_hours, start_date, end_date, location, category} = props.data || {};  
  const { register, errors, control } = props.formConfig; 

  const getTimeFromOccurrence = (occurrences, day) => {
    /* Extract the occurrence from a list by day and parse it to time */
    if(occurrences && occurrences.length > 0){
      const existOccurence = occurrences.find((occurrence) => occurrence.day === day.toLowerCase());
      if(existOccurence){
        return timeStringTodatetime(existOccurence.start_time).toDate()
      }
    }
    return null
  }

  const getOccurrenceError = (errors, attr, day) => {
    if(errors[`${attr}`] && errors[`${attr}`][`${day}`]){
      return errors[`${attr}`][`${day}`].message;
    }
    return null;
  }
  
  return (
    <form noValidate autoComplete="off" >
      <Grid container spacing={3} direction="row">
        <Grid item xs={allowEditUsers ? 6 : 12}>
          <TextField 
            id="filled-basic"
            label="Name"
            name="name"
            placeholder="Course name"
            variant="filled"
            disabled={!isEditableForm || (user && user.data.profile !== 'manager')}
            fullWidth={true}

            defaultValue={name}
            inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
            error={errors.name ? true : false}
            helperText={errors.name ? errors.name.message : null}
          />
        </Grid>
        
        {allowEditUsers && (
          <Grid item xs={6}>          
            <UserSelectionField courseId={id} page={page} courseName={name} />          
          </Grid>
        )}

        <Grid  item xs={6}>
            <Controller 
              as={KeyboardDatePicker}
              disabled={!isEditableForm}
              autoOk
              format="MM/DD/YYYY"
              views={["year", "month", "date"]}
              label="Start Date"
              placeholder="mm/dd/yyyy"
              variant="inline"    
              inputVariant="filled"
              fullWidth={true} 
              error={errors.start_date ? true : false}
              helperText={errors.start_date ? errors.start_date.message : null}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              // rules={{ required: "Field Required", pattern: /^[A-Za-z]+$/i  }}
              name="start_date"               
              control={control} 
              defaultValue={start_date || null} />
          </Grid>

          <Grid  item xs={6}>
            <Controller 
              as={KeyboardDatePicker}
              autoOk
              disabled={!isEditableForm}
              format="MM/DD/YYYY"
              views={["year", "month", "date"]}
              label="End Date"
              placeholder="mm/dd/yyyy"
              variant="inline"    
              inputVariant="filled"
              fullWidth={true} 
              error={errors.end_date ? true : false}
              helperText={errors.end_date ? errors.end_date.message : null}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              name="end_date"               
              control={control} 
              defaultValue={end_date || null} />
          </Grid>

          <Grid  item xs={6}>
            <TextField 
              name="location"                  
              id="location"
              label="Location"                  
              variant="filled"
              fullWidth={true}
              disabled={!isEditableForm}

              defaultValue={location}
              inputRef={register({ minLength: { value: 5, message: "Too short!." } })}
              error={errors.location ? true : false}
              helperText={errors.location ? errors.location.message : null}
            />
          </Grid>
          
        <Grid item xs={6}> 
          <FormControl
            variant="filled" 
            fullWidth={true}
            error={errors.category ? true : false}
            disabled={!isEditableForm || (user && user.data.profile !== 'manager')}
            >
            
            <InputLabel id="category-label">Select Group</InputLabel>
            <Controller
              as={
                <Select labelId="category-label">
                  {categories  && categories.data.results.map( categoryItem => (
                    <MenuItem key={categoryItem.id} value={categoryItem.id}>{categoryItem.name}</MenuItem>
                  ))}
                </Select>
              }
              name="category"
              rules={{ required: "This is required" }}
              control={control}
              defaultValue={category || (categories.data ? categories.data.results[0].id : null)}
            />
            <FormHelperText>{errors.category ? errors.category.message : null}</FormHelperText>            
          </FormControl>
        </Grid>

        <Grid container spacing={3} direction="row" style={{'padding': '0 1em', 'paddingBottom': '1.5em'}}>          
          <Grid item xs={6} className={classes.occurrences}>
            <h3  disabled={!isEditableForm}>Days scheduled</h3>
            {DAYS.map((day) =>(
              <Grid item xs={12} key={`${day}__key__day`} style={{'padding': '0.5em'}}>
               <Controller 
                as={KeyboardTimePicker}
                disabled={!isEditableForm}
                ampm={true}
                format="hh:mm A"
                invalidDateMessage="Invalida time"
                label={`${day}`}
                placeholder="HH:MM AM/PM"
                variant="dialog"    
                clearable={true}
                inputVariant="filled"
                fullWidth={true} 
                error={getOccurrenceError(errors, 'occurrences', day.toLowerCase()) ? true : false }
                helperText={getOccurrenceError(errors, 'occurrences', day.toLowerCase())}
                KeyboardButtonProps={{
                  'aria-label': 'change time',
                }}
                minutesStep={5}
                name={`occurrences.${day.toLowerCase()}`}          
                control={control} 
                rules={
                  { 
                    required: false,
                    pattern: { 
                      value: /^$|null|undefined|((1[0-2]|0?[0-9]):([0-5][0-9]))/, 
                      message: "Bad time format" 
                    }
                  }
                }
                defaultValue={() => getTimeFromOccurrence(occurrences, day)}
              />
            </Grid>
            ))}
          </Grid>

          <Grid item xs={6} className={classes.occurrences}>
            <h3>Office Hours</h3>
            {DAYS.map((day) =>(
              <Grid item xs={12} key={`${day}__key__day`} style={{'padding': '0.5em'}}>
               <Controller 
                as={KeyboardTimePicker}
                disabled={!isEditableForm}
                ampm={true}
                format="hh:mm A"
                invalidDateMessage="Invalida time"
                label={`${day}`}
                placeholder="HH:MM AM/PM"
                variant="dialog"    
                clearable={true}
                inputVariant="filled"
                fullWidth={true} 
                error={getOccurrenceError(errors, 'office_hours', day.toLowerCase()) ? true : false }
                helperText={getOccurrenceError(errors, 'office_hours', day.toLowerCase())}
                KeyboardButtonProps={{
                  'aria-label': 'change time',
                }}
                minutesStep={5}
                name={`office_hours.${day.toLowerCase()}`}          
                control={control} 
                rules={
                  { 
                    pattern: { 
                      value: /^$|null|undefined|((1[0-2]|0?[0-9]):([0-5][0-9]))/, 
                      message: "Bad time format" 
                    }
                  }
                }
                defaultValue={() => getTimeFromOccurrence(office_hours, day)}
              />
            </Grid>
            ))}
          </Grid>

        </Grid>

        <Grid item xs={12}>
          <TextField 
            name="description"                  
            id="description"
            label="Description"                  
            multiline
            variant="filled"
            fullWidth={true}
            disabled={!isEditableForm}
            rows={2}
            rowsMax={5}

            defaultValue={description}
            inputRef={register({ minLength: { value: 5, message: "Too short!." } })}
            error={errors.description ? true : false}
            helperText={errors.description ? errors.description.message : null}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField 
            id="filled-basic"
            name="required_books"
            label="Required books"
            multiline
            variant="filled"
            fullWidth={true}
            rows={2}
            rowsMax={5}
            disabled={!isEditableForm}

            defaultValue={required_books}
            inputRef={register({ minLength: { value: 5, message: "Too short!." } })}
            error={errors.required_books ? true : false}                  
            helperText={errors.required_books ? errors.required_books.message : null}
          />
        </Grid>
        {/* Show Form action buttons only when Edit action is active */}
        {props.children}
      </Grid>
    </form>
  )
}

export default CourseForm;